/**
 * @generated SignedSource<<ca362bc9c9e5f6878331dfc25a1c6942>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SortEnumType = "ASC" | "DESC" | "%future added value";
export type AllSkillsFilterInput = {
  isActive?: boolean | null | undefined;
  skillCode?: string | null | undefined;
  skillName?: string | null | undefined;
  skillType?: string | null | undefined;
  standardGradeIds?: ReadonlyArray<string> | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
  targetIds?: ReadonlyArray<string> | null | undefined;
};
export type SkillSortInput = {
  assessmentInfo?: SortEnumType | null | undefined;
  code?: SortEnumType | null | undefined;
  context?: SortEnumType | null | undefined;
  createdBy?: UserSortInput | null | undefined;
  createdOn?: SortEnumType | null | undefined;
  difficulty?: SortEnumType | null | undefined;
  essentialQuestion?: SortEnumType | null | undefined;
  id?: SortEnumType | null | undefined;
  isActive?: SortEnumType | null | undefined;
  lessonInfo?: SortEnumType | null | undefined;
  mapCutoffScore?: SortEnumType | null | undefined;
  modifiedBy?: UserSortInput | null | undefined;
  modifiedOn?: SortEnumType | null | undefined;
  name?: SortEnumType | null | undefined;
  progressionNotes?: SortEnumType | null | undefined;
  summary?: SortEnumType | null | undefined;
};
export type UserSortInput = {
  createdBy?: UserSortInput | null | undefined;
  createdOn?: SortEnumType | null | undefined;
  email?: SortEnumType | null | undefined;
  externalSync?: ExternalSyncSortInput | null | undefined;
  externalSyncId?: SortEnumType | null | undefined;
  firstName?: SortEnumType | null | undefined;
  fullName?: SortEnumType | null | undefined;
  id?: SortEnumType | null | undefined;
  isActive?: SortEnumType | null | undefined;
  isMetabaseAccessEnabled?: SortEnumType | null | undefined;
  isMetabaseEmailEnabled?: SortEnumType | null | undefined;
  isObfuscated?: SortEnumType | null | undefined;
  lastName?: SortEnumType | null | undefined;
  lastNameFirst?: SortEnumType | null | undefined;
  modifiedBy?: UserSortInput | null | undefined;
  modifiedOn?: SortEnumType | null | undefined;
  owner?: UserSortInput | null | undefined;
  publicUserId?: SortEnumType | null | undefined;
};
export type ExternalSyncSortInput = {
  id?: SortEnumType | null | undefined;
  isObfuscated?: SortEnumType | null | undefined;
  lastUpdatedOn?: SortEnumType | null | undefined;
  source?: SortEnumType | null | undefined;
};
export type MonitoringAllSkillsCSVQuery$variables = {
  after?: string | null | undefined;
  filter: AllSkillsFilterInput;
  first?: number | null | undefined;
  order?: ReadonlyArray<SkillSortInput> | null | undefined;
  skip?: boolean | null | undefined;
};
export type MonitoringAllSkillsCSVQuery$data = {
  readonly allSkills?: {
    readonly nodes: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
    }> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    };
  } | null | undefined;
};
export type MonitoringAllSkillsCSVQuery = {
  response: MonitoringAllSkillsCSVQuery$data;
  variables: MonitoringAllSkillsCSVQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skip"
},
v5 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          },
          {
            "kind": "Variable",
            "name": "order",
            "variableName": "order"
          }
        ],
        "concreteType": "SkillNodeConnection",
        "kind": "LinkedField",
        "name": "allSkills",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MonitoringAllSkillsCSVQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "MonitoringAllSkillsCSVQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "8540dc66b44d829012143546833cde6a",
    "id": null,
    "metadata": {},
    "name": "MonitoringAllSkillsCSVQuery",
    "operationKind": "query",
    "text": "query MonitoringAllSkillsCSVQuery(\n  $filter: AllSkillsFilterInput!\n  $first: Int\n  $after: String\n  $order: [SkillSortInput!]\n  $skip: Boolean = false\n) {\n  allSkills(filter: $filter, first: $first, after: $after, order: $order) @skip(if: $skip) {\n    nodes {\n      id\n      code\n      name\n    }\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9ef47b39e43a20e826f1d3c0e6153adf";

export default node;
